import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import LanguageSwitcher from 'components/cleanui/layout/TopBar/LanguageSwitcher'

import classNames from 'classnames'
// import SupportChat from 'components/cleanui/layout/SupportChat'
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const OnBoardingLayout = ({ children, logo, isGrayTopbar }) => (
  <Layout>
    <Layout.Content>
      {/*         <SupportChat />
       */}
      <div className={style.container}>
        <div
          className={classNames(`${style.topbar}`, {
            [style.topbarGray]: isGrayTopbar,
          })}
        >
          <div className={style.logoContainer}>
            <div className={style.logo}>
              <img
                src="/resources/images/logo-Mobidoc-inline.png"
                className={`${style.image} me-2`}
                alt="Mobidoc"
              />
              {logo === 'Mobidoc' && <div className={style.descr}>Your personal assistant</div>}
            </div>
          </div>
          <div className="d-none d-sm-block">
            <LanguageSwitcher />
          </div>
        </div>
        <div className={style.containerInner}>{children}</div>
        <div className="mt-auto pb-5 pt-5">
          <ul
            className={`${style.footerNav} list-unstyled d-flex mb-0 flex-wrap justify-content-center`}
          >
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Terms of Use
              </a>
            </li>
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Compliance
              </a>
            </li>
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Support
              </a>
            </li>
            <li>
              <a href="#" onClick={e => e.preventDefault()}>
                Contacts
              </a>
            </li>
          </ul>
          <div className="text-center">
            Copyright © 2017-2020 Mobidoc SA |{' '}
            <a href="https://getmobidoc.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </Layout.Content>
  </Layout>
)

export default withRouter(connect(mapStateToProps)(OnBoardingLayout))
